<admin-header [primaryButtons]="headerPrimaryButtons" [secondaryButtons]="headerSecondaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="parameters" [showColonAfterLabel]="true" labelLocation="top">
		<dxi-item><p>This report pulls together all Outside Process Contract Movements which have been sent but not yet received. It has no parameters.</p></dxi-item>
	</dx-form>
</div>
